var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeacherFeedbackBadge = function SvgTeacherFeedbackBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h34v34H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    strokeWidth: 2,
    fill: "#DBFADF",
    fillRule: "nonzero",
    cx: 17,
    cy: 17,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5h20v20H7z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.333c-.92 0-1.667.746-1.667 1.667v10.833c0 .92.747 1.667 1.667 1.667H22l4.167 4.167V10c0-.92-.746-1.667-1.667-1.667h-15zm1.667 9.167h7.5v1.667h-7.5V17.5zm0-3.333h11.666v1.666H11.167v-1.666zm0-3.334h11.666V12.5H11.167v-1.667z",
    fill: "#4EA15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.833A1.163 1.163 0 0 0 8.333 10v10.833A1.163 1.163 0 0 0 9.5 22h12.707l3.46 3.46V10A1.163 1.163 0 0 0 24.5 8.833h-15z",
    stroke: "#378142"
  })))));
};

export default SvgTeacherFeedbackBadge;